export type PlansTrackingParams = {
    source: string;
    panelId?: string;
};

/**
 * プランページをトラッキング用パラメータ付きで新しいタブで開く
 */
export function openPlansWithTracking(params: PlansTrackingParams) {
    const searchParams = new URLSearchParams();
    // DBの session_context (VARCHAR(64)) に入れる想定の値を組み立て
    const sessionContextBase = params.panelId
        ? `${params.source}_${params.panelId}`
        : params.source;
    const sessionContext = sessionContextBase.slice(0, 64);

    // 決済セッション作成時に使われる sessionContext
    searchParams.set('sessionContext', sessionContext);

    // 追加の分析用パラメータ（必要に応じてフロント側で利用）
    searchParams.set('from', params.source);
    if (params.panelId) {
        searchParams.set('panel', params.panelId);
    }

    const url = `/plans?${searchParams.toString()}`;
    window.open(url, '_blank', 'noopener,noreferrer');
}


